export default "<markdown fxFlexFill [data]=\"answer.questionRef.text\" ></markdown>\n";